module.exports = __webpack_public_path__ + "img/TCALCI_specific_male_90.dbcb2937.png";